import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface SalesFilters {
  searchText: string;
  dateRange: Date[] | null;
  activeQuickFilter: 'today' | 'week' | 'month' | 'all' | null;
}

@Injectable()
export class SalesFilterService {
  private readonly defaultFilters: SalesFilters = {
    searchText: '',
    dateRange: null,
    activeQuickFilter: 'month',
  };

  private filtersSubject = new BehaviorSubject<SalesFilters>({
    ...this.defaultFilters,
  });
  public filters$ = this.filtersSubject.asObservable();

  get currentFilters(): SalesFilters {
    return this.filtersSubject.value;
  }

  updateFilters(filters: Partial<SalesFilters>): void {
    this.filtersSubject.next({
      ...this.filtersSubject.value,
      ...filters,
    });
  }

  setSearchText(searchText: string): void {
    this.updateFilters({ searchText });
  }

  setDateRange(dateRange: Date[] | null): void {
    this.updateFilters({ dateRange, activeQuickFilter: null });
  }

  setQuickFilter(preset: 'today' | 'week' | 'month' | 'all'): void {
    this.updateFilters({ activeQuickFilter: preset });
  }

  clearFilters(): void {
    this.filtersSubject.next({
      ...this.defaultFilters,
      activeQuickFilter: 'all',
    });
  }

  hasActiveFilters(): boolean {
    const filters = this.currentFilters;
    return !!(
      filters.searchText ||
      filters.dateRange?.length ||
      (filters.activeQuickFilter && filters.activeQuickFilter !== 'all')
    );
  }
}
